import {Component, ElementRef, EventEmitter, Input, signal, WritableSignal, inject, ChangeDetectionStrategy} from '@angular/core';
import {MatCheckbox} from '@angular/material/checkbox';

@Component({
	selector: 'app-select-option',
	templateUrl: './select-option.component.html',
	styleUrls: ['../multi-select.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [MatCheckbox]
})
export class SelectOptionComponent {
	elementRef = inject(ElementRef);

	@Input() value: any;
	@Input() separator: boolean;
	@Input() disabled = false;

	selectChanges: EventEmitter<void> = new EventEmitter<void>();
	selected: WritableSignal<boolean> = signal(false);
	multiple: WritableSignal<boolean> = signal(false);
	prefix: WritableSignal<boolean> = signal(false);
	inDeleteMode: WritableSignal<boolean> = signal(false);
	inEditMode: WritableSignal<boolean> = signal(false);

	onSelect(): void {
		this.selected.update(s => !s);
		this.selectChanges.emit();
	}
}
